import { Location } from '@angular/common';
import { AfterContentChecked, ChangeDetectionStrategy, ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup } from "@angular/forms";
import { ActivatedRoute, Router } from '@angular/router';
import FingerprintJS from '@fingerprintjs/fingerprintjs';
import { GeolocationService } from '@ng-web-apis/geolocation';
import * as CryptoJS from 'crypto-js';
import * as _ from 'lodash';
import { NzNotificationService } from "ng-zorro-antd";
import { take } from 'rxjs/operators';
import { AuthenticateRequestModel } from 'src/app/models/authenticate-response.model';
import { AuthenticateService } from 'src/app/services/authenticate.service';
import { ConfigService } from 'src/app/services/config.service';
import * as Constants from 'src/app/utils/constants';
import { DISTANCE_ACCEPT, GEOLOCATION } from 'src/app/utils/constants';
import { QR_DATA } from 'src/app/utils/session.config';
import { environment } from 'src/environments/environment';
import { GetBranchCodeModel, GetInfoQueueModel, GetInfomationCustomerModel, GetQueueBookingModel } from '../../models/queues-get.models';
import { Customer, Product, ProductGroup } from '../../models/queues-response.models';
import { QueuesService } from '../../services/queues.service';
import { VerifyService } from '../../services/verify-signature.service';

@Component({
  selector: 'app-component-transaction-queue',
  templateUrl: './transaction-queue.component.html',
  styleUrls: ['./transaction-queue.component.css'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TransactionqueueComponent implements OnInit, AfterContentChecked {

  lstgroup: ProductGroup[];
  lstProduct: Product[];
  infoCustomer: Customer;
  model: GetInfomationCustomerModel = { FilterText: "", IsCorp: false };
  modelQueueBooking: GetQueueBookingModel = { Code: "", SearchByIdentity: false };
  phone: string = "";
  queuestt: string;
  isKhVangLai: boolean;
  selectedGroupId: number;
  orgCode: string;
  isSelected = 0;
  titile: string;
  isSpinning: boolean;
  isValid: boolean = true;
  visitorId: string;
  counter: string;
  isSkip: boolean = false;
  customerName: string;
  branchName: string;
  productName: string;
  msgError: string;
  isZaloChannel: boolean = true;
  isEwallet: boolean = false;
  statusQueue: number;
  max_Distance: number;
  customer: Customer;
  isHeader: boolean = true;
  linkUrl: string;
  cuscde: string;
  dataQR: string;
  authenticateForm: FormGroup;
  isVisibleLoginModal = false;
  isVisibleWarningModal = false;
  isLoadingButtonInModal = false;
  isAuthenticated = false;
  isWarningExpiration = false;
  isGeolocation = false;
  splitTypeCus = false;

  constructor(
    private route: ActivatedRoute,
    private verifyService: VerifyService,
    private router: Router,
    private queuesService: QueuesService,
    private location: Location,
    private geolocation: GeolocationService,
    private cdref: ChangeDetectorRef,
    private nzModalNotification: NzNotificationService,
    private authenticateService: AuthenticateService,
    private formBuilder: FormBuilder,
    private configSevice: ConfigService) {
    this.max_Distance = this.configSevice.get(DISTANCE_ACCEPT);
    this.isGeolocation = this.configSevice.get(GEOLOCATION);

    //Layer 1
    // Initialize an agent at application startup.
    const fpPromise = FingerprintJS.load();
    (async () => {
      // Get the visitor identifier when you need it.
      const fp = await fpPromise
      const result = await fp.get()
      let uid = result.visitorId;

      //Generate deviceId indentifier unique
      //Layer2
      let navigator_info = window.navigator;
      let screen_info = window.screen;
      uid += navigator_info.mimeTypes.length.toString();
      uid += navigator_info.userAgent.replace(/\D+/g, '');
      uid += navigator_info.plugins.length;
      uid += screen_info.height || '';
      uid += screen_info.width || '';
      uid += screen_info.pixelDepth || '';
      this.visitorId = uid;

      this.linkUrl = this.router.url;
      this.authenticateForm = this.formBuilder.group({
        username: null,
        password: null
      });

      this.route.queryParams.subscribe(params => {
        this.isSpinning = true;
        let cusname = params["cusname"];
        let cuscde = params["cuscde"];
        let cusphone = params["cusphone"];
        let ref = params["ref"];
        this.dataQR = params["data"];
        this.cuscde = cuscde;

        if (ref) {
          this.phone = cusphone;
          this.isHeader = false;
          this.isZaloChannel = false;
          let dataExtra = { Cuscode: cuscde, Ref: ref };

          if (!cusname || cusname == "null" || cusname == "undefined") {
            this.queuesService.getCustomerByPhone({ IsCorp: false, FilterText: cusphone }).subscribe(response => {
              if (response.result.isSuccess) {
                if (!this.customerName)
                  this.customerName = response.result.value.result.fullName == '' ? cusphone : response.result.value.result.fullName.toUpperCase().trim().replace(/ +(?= )/g, "");

                this.customer = response.result.value.result;
                this.isZaloChannel = !response.result.value.result.ewallName;
                this.isEwallet = !!response.result.value.result.ewallName;
              }
              else
                return this.router.navigate(["page-not-found"], { state: dataExtra });
            }, error => {
              return this.router.navigate(["page-not-found"], { state: dataExtra });
            });
          } else {
            this.customerName = cusname;
          }
        };

        if (!this.dataQR) {
          let localStoragedataQR = localStorage.getItem(QR_DATA);
          if (localStoragedataQR) {
            this.dataQR = localStoragedataQR;
          }
        } else {
          localStorage.setItem(QR_DATA, this.dataQR);
        }

        //Layer 3
        //Generate deviceId indentifier unique
        if (this.dataQR) {
          let dataDecrypt = JSON.parse(this.decryptData(this.dataQR));
          if (dataDecrypt.CompanyCode) {
            this.visitorId += dataDecrypt.CompanyCode.replace(/\D+/g, '');
            this.orgCode = dataDecrypt.CompanyCode;
          } else {
            let dataExtra = { Cuscode: cuscde, Ref: ref };
            return this.router.navigate(["page-not-found"], { state: dataExtra });
          }
        }
        else {
          let dataExtra = { Cuscode: cuscde, Ref: ref };
          return this.router.navigate(["page-not-found"], { state: dataExtra });
        }

        let requestdata: GetBranchCodeModel = {
          DataQr: this.dataQR,
          OrgCode: this.orgCode,
          VisitorId: this.visitorId,
          MobilePhone: this.phone,
          IsSCP: !this.isZaloChannel,
          UrlQR: this.linkUrl,
          IsRequestFromCVTV: this.isAuthenticated
        };

        this.verifyService.queueVerifySignature(requestdata).subscribe(res => {
          if (res.valid) {
            this.orgCode = res.info;
            this.branchName = res.branchName;
            this.location.replaceState("/lay-so-giao-dich");

            if (res.isExist) {
              this.isSelected = 1;
              this.isSpinning = false;
              this.queuestt = res.orderId;
              this.isZaloChannel = res.zaloChannel;
              this.phone = res.mobilePhone;
              this.customerName = res.fullName;
              this.counter = this.padWithLeadingZeros(res.counter, 2);
              this.statusQueue = res.status;
              this.selectedGroupId = Number(res.groupId);
              this.isEwallet = !res.zaloChannel;
              this.getProductGroups();
            }
            else {
              if (this.isGeolocation) {
                this.geolocation.pipe(take(1)).subscribe(
                  (position) => {
                    let distance = this.distance(res.latitude, res.longitude, position.coords.latitude, position.coords.longitude)
                    let dataExtra = { Cuscode: cuscde, Distance: distance, Ref: ref };

                    if (distance > this.max_Distance) {
                      return this.router.navigate(["lay-so-giao-dich?errorCode=645"], { state: dataExtra });
                    }
                    else {
                      this.getProductGroups();
                      this.isSpinning = false;
                    }
                  }, (error) => {
                    console.log(error);
                    let dataExtra = { Cuscode: cuscde, Ref: ref };
                    return this.router.navigate(["lay-so-giao-dich?errorCode=646"], { state: dataExtra });
                  });
              } else {
                this.getProductGroups();
                this.isSpinning = false;
              }
            }
          }
          else {
            let dataExtra = { Cuscode: cuscde, Ref: ref };
            return this.router.navigate(["page-not-found"], { state: dataExtra });
          }
        })
      });
    })()
  }

  ngOnInit(): void {
    this.authenticateService.autoLogin();
    this.authenticateService.userSub.subscribe((user) => {
      this.isAuthenticated = user ? true : false;
      this.isVisibleWarningModal = false;
    });

    this.authenticateService.timeoutSub.subscribe((value) => {
      this.isWarningExpiration = value ? true : false;
      if (this.isWarningExpiration) {
        this.isVisibleWarningModal = true;
      }
    });
  }

  decryptData(valor: string): any {
    var key = CryptoJS.MD5(CryptoJS.enc.Utf16LE.parse(environment.hash));
    var encrypted = CryptoJS.TripleDES.decrypt(valor, key, { mode: CryptoJS.mode.ECB }).toString(CryptoJS.enc.Utf16LE);
    return encrypted;
  }

  ngAfterContentChecked() {
    this.cdref.detectChanges();
  }

  distance(x: number, y: number, currentX: number, currentY: number): number {
    let earthRadius = 3958.75;
    let radians = 180 / 3.14159265;
    let metres_in_mile = 1609.34;

    let latitude = x / radians;
    let longitude = y / radians;
    let currentlatitude = currentX / radians;
    let currentlongitude = currentY / radians;

    let result = (earthRadius * metres_in_mile) * Math.acos(Math.sin(latitude) * Math.sin(currentlatitude) + Math.cos(latitude) * Math.cos(currentlatitude) * Math.cos(currentlongitude - longitude))
    return result;
  }

  getProductGroups() {
    this.isSpinning = true;
    this.queuesService.getProductGroups(this.orgCode).subscribe(response => {
      if (response) {
        this.lstgroup = response.filter(x => x.isActive);
        let groupType = _.uniqWith(this.lstgroup.filter(x => x.groupName), 'groupName');
        console.log(groupType)
        console.log(groupType.length > 1)
        this.splitTypeCus = groupType.length > 1;

        let productSelected = this.lstgroup.filter(x => x.isActive && x.id == this.selectedGroupId);
        if (productSelected && productSelected.length > 0)
          this.productName = productSelected[0].name;

        this.isSpinning = false;
      }
      else {
        return this.router.navigate(["page-not-found"]);
      }
    }, error => {
      return this.router.navigate(["page-not-found"]);
    });
  }

  selectedService(stt: any, groupid: number) {
    this.isSpinning = true;
    let regexPattern = new RegExp("^((84|0[1-9])+([0-9]{8}))$");

    if (!this.isAuthenticated && this.phone?.toUpperCase() == "STB") {
      this.showLoginModal();
      this.isSpinning = false;
      return;
    }

    if (this.phone == '') {
      this.msgError = "Vui lòng nhập số điện thoại";
      this.isValid = false;
      this.isSpinning = false;
      return;
    }

    if (this.phone.length != 10 || !this.phone.match(regexPattern)) {
      this.msgError = "Vui lòng nhập đúng định dạng số điện thoại";
      this.isValid = false;
      this.isSpinning = false;
      return;
    }

    //Double check in cache again
    if (this.isZaloChannel) {
      let requestdata: GetBranchCodeModel = {
        DataQr: this.dataQR,
        OrgCode: this.orgCode,
        VisitorId: this.visitorId,
        MobilePhone: this.phone,
        IsSCP: !this.isZaloChannel,
        UrlQR: this.linkUrl,
        IsRequestFromCVTV: this.isAuthenticated
      };

      this.queuesService.getQueueInCache(requestdata).subscribe(res => {
        if (res && res.result) {
          this.orgCode = res.result["branchCode"];
          this.isSelected = 1;
          this.isSpinning = false;
          this.queuestt = res.result["orderId"];
          this.isZaloChannel = res.result["isZalo"];
          this.phone = res.result["mobilePhone"];
          this.customerName = res.result["customerName"];
          this.counter = this.padWithLeadingZeros(res.result["counter"], 2);
          this.statusQueue = res.result["status"];
          this.selectedGroupId = Number(res.result["groupId"]);
          this.isEwallet = !res.result["isZalo"];
          this.getProductGroups();
        } else {
          if (this.customer) {
            this.customer.ProductGroupId = groupid;
            this.customer.orgCode = this.orgCode;
            this.checkExistQueue(this.customer, stt);
          } else {
            this.model.IsCorp = false;
            if (this.cuscde && this.cuscde != "null" && this.cuscde != "undefined") {
              this.model.FilterText = this.cuscde;
              this.queuesService.getCustomerByCode(this.model).subscribe(response => {
                if (response.result.isSuccess) {
                  response.result.value.result.ProductGroupId = groupid;
                  response.result.value.result.orgCode = this.orgCode;
                  if (!this.customerName)
                    this.customerName = response.result.value.result.fullName == '' ? this.phone : response.result.value.result.fullName;

                  this.isZaloChannel = !response.result.value.result.ewallName;
                  this.isEwallet = !!response.result.value.result.ewallName;
                  this.checkExistQueue(response.result.value.result, stt);
                }
                else {
                  return this.router.navigate(["page-not-found"]);
                }
              }, error => {
                return this.router.navigate(["page-not-found"]);
              })
            } else {
              this.model.FilterText = this.phone;
              this.queuesService.getCustomerByPhone(this.model).subscribe(response => {
                if (response.result.isSuccess) {
                  response.result.value.result.ProductGroupId = groupid;
                  response.result.value.result.orgCode = this.orgCode;
                  if (!this.customerName)
                    this.customerName = response.result.value.result.fullName == '' ? this.phone : response.result.value.result.fullName;

                  this.isZaloChannel = !response.result.value.result.ewallName;
                  this.isEwallet = !!response.result.value.result.ewallName;
                  this.checkExistQueue(response.result.value.result, stt);
                }
                else {
                  return this.router.navigate(["page-not-found"]);
                }
              }, error => {
                return this.router.navigate(["page-not-found"]);
              })
            }

            this.selectedGroupId = groupid;
            let productSelected = this.lstgroup.filter(x => x.isActive && x.id == this.selectedGroupId);
            if (productSelected)
              this.productName = productSelected[0].name;
          }
        }
      });
    } else {
      if (this.customer) {
        this.customer.ProductGroupId = groupid;
        this.customer.orgCode = this.orgCode;
        this.checkExistQueue(this.customer, stt);
      } else {
        this.model.IsCorp = false;
        if (this.cuscde && this.cuscde != "null" && this.cuscde != "undefined") {
          this.model.FilterText = this.cuscde;
          this.queuesService.getCustomerByCode(this.model).subscribe(response => {
            if (response.result.isSuccess) {
              response.result.value.result.ProductGroupId = groupid;
              response.result.value.result.orgCode = this.orgCode;
              if (!this.customerName)
                this.customerName = response.result.value.result.fullName == '' ? this.phone : response.result.value.result.fullName;

              this.isZaloChannel = !response.result.value.result.ewallName;
              this.isEwallet = !!response.result.value.result.ewallName;
              this.checkExistQueue(response.result.value.result, stt);
            }
            else {
              return this.router.navigate(["page-not-found"]);
            }
          }, error => {
            return this.router.navigate(["page-not-found"]);
          })
        } else {
          this.model.FilterText = this.phone;
          this.queuesService.getCustomerByPhone(this.model).subscribe(response => {
            if (response.result.isSuccess) {
              response.result.value.result.ProductGroupId = groupid;
              response.result.value.result.orgCode = this.orgCode;
              if (!this.customerName)
                this.customerName = response.result.value.result.fullName == '' ? this.phone : response.result.value.result.fullName;

              this.isZaloChannel = !response.result.value.result.ewallName;
              this.isEwallet = !!response.result.value.result.ewallName;
              this.checkExistQueue(response.result.value.result, stt);
            }
            else {
              return this.router.navigate(["page-not-found"]);
            }
          }, error => {
            return this.router.navigate(["page-not-found"]);
          })
        }
      }

      this.selectedGroupId = groupid;
      let productSelected = this.lstgroup.filter(x => x.isActive && x.id == this.selectedGroupId);
      if (productSelected)
        this.productName = productSelected[0].name;
    }
  }

  checkExistQueue(data: Customer, stt: any) {
    let modelInfoQueue = new GetInfoQueueModel();
    modelInfoQueue.OrgCode = this.orgCode;
    modelInfoQueue.FullName = this.customerName;
    modelInfoQueue.ProductGroupId = this.selectedGroupId;
    modelInfoQueue.VisitorId = this.visitorId;
    modelInfoQueue.IsZalo = this.isZaloChannel;
    modelInfoQueue.PhoneNumber = this.phone;
    modelInfoQueue.CustomerCode = data.customerCode;
    modelInfoQueue.IsRequestFromCVTV = this.isAuthenticated;

    data.branchCode = this.orgCode;
    data.visitorId = this.visitorId;
    data.phone = this.phone;
    data.fullName = this.customerName;
    data.isZalo = this.isZaloChannel;
    data.isRequestFromCVTV = this.isAuthenticated;

    this.queuesService.getExistQueue(modelInfoQueue).subscribe(res => {
      if (res.result.isSuccess) {
        if (res.result.value.result == "" || !res.result.value.result) {
          this.queuesService.createNewQueue(data).subscribe(response => {
            if (response.result.isSuccess) {
              this.queuestt = response.result.value.result;
              this.titile = "thành công";
              this.isSelected = stt;
              this.isSpinning = false;
            }
            else if (response.result.error == Constants.IP_BLOCK_CODE) {
              this.nzModalNotification.error("Hệ thống bận", "Vui lòng thử lại sau " + (response.result.messageError == Constants.IP_BLOCK_MESSAGE ? "5 phút!" : "ít phút!"));
              this.isSpinning = false;
            }
            else {
              return this.router.navigate(["page-not-found"]);
            }
          }, error => {
            return this.router.navigate(["page-not-found"]);
          })
        }
        else {
          this.queuestt = res.result.value.result.queueNumber;
          this.statusQueue = res.result.value.result.status;
          this.counter = this.padWithLeadingZeros(res.result.value.result.counter, 2);
          let productSelected = this.lstgroup.filter(x => x.isActive && x.id == res.result.value.result.productGroupId);
          if (productSelected)
            this.productName = productSelected[0].name;

          this.isSelected = stt;
          this.isSpinning = false;
        }
      }
      else {
        return this.router.navigate(["page-not-found"]);
      }
    }, error => {
      return this.router.navigate(["page-not-found"]);
    });
  }

  collectForm(stt) {
    this.isSpinning = true;
    let temp = this.lstgroup.find(x => x.id == this.selectedGroupId).products;
    if (temp == null) {
      return this.router.navigate(["page-not-found"]);
    }
    this.lstProduct = temp.filter(x => x.isActive);
    this.isSelected = stt;
    this.isSpinning = false;
  }

  selectForm(formcode: string) {
    if (formcode && formcode != "") {
      this.router.navigate(["eform"], { state: { Code: formcode } })
    }
    else {
      this.nzModalNotification.error("Error", "Biểu mẫu chưa được hỗ trợ online");
    }
  }

  showLoginModal() {
    this.isVisibleLoginModal = true;
  }

  cancelLoginModal() {
    this.isVisibleLoginModal = false;
  }

  cancelWarningModal() {
    this.isVisibleWarningModal = false;
  }

  validateLoginModal(): boolean {
    if (!this.authenticateForm.get('username').value) {
      this.nzModalNotification.warning(
        "WARNING",
        "Vui lòng nhập Tên đăng nhập"
      );
      return false;
    }

    if (!this.authenticateForm.get('password').value) {
      this.nzModalNotification.warning(
        "WARNING",
        "Vui lòng nhập Mật khẩu"
      );
      return false;
    }

    return true;
  }

  submitLoginModal() {
    if (!this.validateLoginModal()) {
      return;
    }
    this.isLoadingButtonInModal = true;
    var formValue = this.authenticateForm.value;
    var authenrequestModel = new AuthenticateRequestModel();
    authenrequestModel.username = formValue.username;
    authenrequestModel.password = formValue.password;

    this.authenticateService.requestLogin(authenrequestModel).subscribe(
      res => {
        if (res) {
          if (res.isValid) {
            this.nzModalNotification.success("Thông báo", "Đăng nhập thành công!");
            this.authenticateService.handleUserSession(res);
            this.authenticateService.saveDataQR(this.dataQR);
            this.isVisibleLoginModal = false;
            this.phone = '';
          } else if (res.user && res.user.username) {
            this.nzModalNotification.warning("Thông báo", "Sai mật khẩu!");
          } else {
            this.nzModalNotification.warning("Thông báo", "Tên đăng nhập không tồn tại!");
          }
        } else {
          this.nzModalNotification.warning("Thông báo", "Lỗi đăng nhập!");
        }
      },
      err => {
        this.nzModalNotification.error("Cảnh báo", "Có lỗi xảy ra!");
      },
      () => {
        this.isLoadingButtonInModal = false;
      }
    );
  }

  logout() {
    this.isLoadingButtonInModal = true;
    this.authenticateService.logout();
    this.nzModalNotification.success("Thông báo", "Đăng xuất thành công!");
    this.isLoadingButtonInModal = false;
  }

  confirmExtendSessionModal() {
    this.isVisibleWarningModal = false;
    this.isLoadingButtonInModal = true;
    this.authenticateService.extendExpiration();
    this.isLoadingButtonInModal = false;
  }

  backToSelectService() {
    if (this.isAuthenticated) {
      this.visitorId = null;
      this.phone = '';
      this.isSelected = 0;
      this.customer = null;
      this.customerName = null;
      this.isZaloChannel = true;
      return this.router.navigate(["lay-so-giao-dich"], { queryParams: { data: this.dataQR } });
    }
  }

  padWithLeadingZeros(num, totalLength) {
    return String(num).padStart(totalLength, '0');
  }
}